"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var withContext_1 = require("../../utils/hoc/withContext");
var propTypes = {
    note: PropTypes.string
};
var defaultProps = {
    note: undefined
};
var ElementWithNoteWithinContext = /** @class */ (function (_super) {
    __extends(ElementWithNoteWithinContext, _super);
    function ElementWithNoteWithinContext(props) {
        var _this = _super.call(this, props) || this;
        _this.noteId = props.ergoElements.idGenerator.next();
        return _this;
    }
    ElementWithNoteWithinContext.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, note = _a.note, ergoElements = _a.ergoElements, other = __rest(_a, ["children", "className", "note", "ergoElements"]);
        var componentClassName = classNames(className, 'ee_element-with-note');
        return (React.createElement("span", __assign({ className: componentClassName }, other),
            React.createElement("span", { className: "ee_element-with-note__wrapper" }, React.isValidElement(children)
                ? React.cloneElement(children, {
                    'aria-describedby': note && this.noteId
                })
                : children),
            note && (React.createElement("span", { id: this.noteId, className: "ee_element-with-note__note" }, note))));
    };
    ElementWithNoteWithinContext.propTypes = propTypes;
    ElementWithNoteWithinContext.defaultProps = defaultProps;
    return ElementWithNoteWithinContext;
}(react_1.Component));
/**
 * This component makes it possible to add a note to an arbitrary element.
 * The note will be shown below the element. Its width is aligned with the width
 * of the element.
 */
exports.ElementWithNote = withContext_1.withErgoElementsContext('ElementWithNote', ElementWithNoteWithinContext);
exports.default = exports.ElementWithNote;
//# sourceMappingURL=ElementWithNote.js.map
